import React from "react";
import { mapToSelect } from "@common/components/helpers/forms";
import {
  Form,
  FormInput,
  Grid,
  Button,
  GridColumn,
  GridRow,
  Modal,
  ModalActions,
  Header,
  FormRadio,
  Select,
} from "semantic-ui-react";
import { camelCaseToText } from "../../helpers";

class ComplianceModal extends React.Component {
  state = {
    loading: false,
    selectedType: null,
    formData: {},
  };
  checkCanSubmit = () => {
    return this.state.selectedEventId || this.state.description;
  };
  handleChangeEvent = (event) => {
    if (!this.props.eventTypeId) {
      this.setState({ ...this.state, selectedEventId: event.target.value });
    }
  };

  componentDidMount() {
    this.setState({ formData: this.props.model });
  }

  componentDidUpdate(prevProps) {
    if (this.props.data && this.props.data !== prevProps.data) {
      this.setState({ formData: this.props.data });
    }

    if (
      !this.props.data &&
      (this.props.data !== prevProps.data ||
        this.props.model !== prevProps.model)
    ) {
      this.setState({ formData: this.props.model });
    }
  }

  handleChange = (_, { name, value }) => {
    this.setState({
      formData: { ...this.state.formData, [name]: value },
    });
  };

  handleToggleChange = (_e, { name, checked }) => {
    this.setState({ formData: { ...this.state.formData, [name]: checked } });
  };

  handleSave = async () => {
    this.setState({ loading: true });
    await this.props.onSave(this.state.formData);
    this.setState({ loading: false });
    this.props.onClose();
  };

  isVisiableField = (field) => {
    return (
      field !== "rowVersion" &&
      field !== "id" &&
      field !== "lastUpdated" &&
      field !== "eventType" &&
      field !== "incidentType"
    );
  };

  mapFieldNames = (field) => {
    switch (field) {
      case "isDisabled":
        return "Hide";
      case "ordinal":
        return "Order";

      default:
        return field;
    }
  };

  isRadioField = (field) => {
    return typeof this.state.formData[field] === "boolean";
  };

  isSelect(field) {
    return ["incidentTypeId", "eventTypeId"].includes(field);
  }

  // @TODO: Fix this non-sense written by Marius
  getValue(key) {
    // Check if value is an object
    return typeof this.state.formData[key] === "object" &&
      this.state.formData[key] !== null
      ? (this.state.formData[key].name ??
          this.state.formData[key].id ??
          JSON.stringify(this.state.formData[key]))
      : (this.state.formData[key] ?? "");
  }
  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeIcon
        size="large"
      >
        <Header>{this.props.title}</Header>
        <Modal.Content style={{ minHeight: "100px" }}>
          <Form onSubmit={this.handleSave}>
            <Grid container>
              {this.state.formData &&
                Object.keys(this.state.formData).map((key) =>
                  this.isVisiableField(key) ? (
                    <GridRow key={key}>
                      <GridColumn width={4} className="capitalize-first-letter">
                        {camelCaseToText(this.mapFieldNames(key))}
                      </GridColumn>
                      <GridColumn width={12}>
                        {this.isRadioField(key) ? (
                          <FormRadio
                            toggle
                            name={key}
                            key={key}
                            checked={this.state.formData[key]}
                            onChange={this.handleToggleChange}
                          ></FormRadio>
                        ) : this.isSelect(key) ? (
                          <Select
                            options={mapToSelect(
                              key === "incidentTypeId"
                                ? this.props.incidentTypes
                                : this.props.eventTypes,
                            )}
                            value={this.getValue(key)}
                            onChange={this.handleChange}
                            name={key}
                            key={key}
                          />
                        ) : (
                          <FormInput
                            type="text"
                            value={this.getValue(key)}
                            name={key}
                            key={key}
                            required
                            onChange={this.handleChange}
                          />
                        )}
                      </GridColumn>
                    </GridRow>
                  ) : (
                    <></>
                  ),
                )}
            </Grid>
          </Form>
        </Modal.Content>
        <ModalActions>
          <Button negative onClick={this.props.onClose}>
            Cancel
          </Button>
          <Button
            positive
            onClick={this.handleSave}
            loading={this.state.loading}
            disabled={this.state.loading}
            icon="save"
          >
            Save
          </Button>
        </ModalActions>
      </Modal>
    );
  }
}

export default ComplianceModal;
